/** Copyright (c) 2022-present TVM Engineering Authors. */
import { primaryColor } from "./defaultStyles";
import SINGUP_BACKGROUND from "../assets/img/landing_main_background.png";

const authStyles = (theme) => ({
  root: {
    paddingLeft: "25%",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "25%",
      // paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    // marginTop: theme.spacing(4),
    justify: "center",
    paddingTop: "4%",
    paddingBottom: "4%",
    borderRadius: "0px",
    background: "#DDE5EF",
    // minHeight: "300px",
  },
  signetOutText: {
    minHeight: "750px",
    backgroundImage: `url(${SINGUP_BACKGROUND})`,
    backgroundSize: "cover",
    padding: "50px 7.5% 40px 7.5%",
    textAlign: "center",
  },
  "@media (min-width: 1024px)": {
    root: {
      paddingLeft: "25%",
      // paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "25%",
        // paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      paddingTop: "4%",
      paddingBottom: "4%",
      background: "#DDE5EF",
    },
  },
  buttonAlign: {
    marginTop: 15,
    width: "100%",
  },
  signInText: {
    padding: "5px 10px 5px 10px",
    border: "1px solid #A9A9A9",
    width: "94%",
    backgroundColor: "#EFEFEF",
  },
  signInTitle: {
    marginBottom: "12px",
  },
  iconColor: {
    color: primaryColor,
    paddingRight: "5px",
  },
  goBackButton: {
    marginTop: 10,
  },
  signedOut: {
    color: "#fff",
  },
  signedOutDescription: {
    color: "#fff",
  },
});

export default authStyles;
